export enum OperationStatus {
  ACTIVE = "Active",
  HOLD = "Hold",
  FINAL = "Final",
  DROPPED = "Dropped",
}
